import * as React from "react";
import ReactPlayer, { ReactPlayerProps } from "react-player";

import styled from "../../theme/styled";
import { HalfColumnWidthWrapper } from "../confines-wrappers";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  videoUrl: string;
  videoCaption?: string;
  videoCaptionColour?: string;
  autoplay?: boolean;
  reactPlayer?: Omit<ReactPlayerProps, "url">;
}

interface IDynamicVideoStyled {
  videoCaptionColour?: string;
}

const DynamicVideoStyled = styled<IDynamicVideoStyled, "div">("div")`
  .caption {
    padding-top: 0.8rem;
    color: ${props => props.videoCaptionColour || "inherit"};
    text-align: center;
    font-style: italic;
  }
`;

/**
 * Returns the appropriate video output depending on the given data
 */
const DynamicVideo: React.FC<IProps> = ({
  videoUrl,
  videoCaption,
  videoCaptionColour,
  autoplay,
  reactPlayer,
  ...rest
}: IProps) => {
  return (
    <DynamicVideoStyled
      videoCaptionColour={videoCaptionColour}
      {...rest}
    >
      <div className="video-container">
        <ReactPlayer
          className="video"
          width="100%"
          height="100%"
          url={videoUrl}
          playing={reactPlayer?.playing || autoplay}
          loop={reactPlayer?.loop || autoplay}
          muted={reactPlayer?.muted || autoplay}
          config={reactPlayer?.config || {
            youtube: {
              playerVars: {
                rel: 0,
                iv_load_policy: 3,
                showinfo: 0,
                controls: 1
              }
            },
            vimeo: { playerOptions: { controls: true } }
          }}
        />
      </div>

      {videoCaption && (
        <HalfColumnWidthWrapper>
          <p className="caption">
            {videoCaption}
          </p>
        </HalfColumnWidthWrapper>
      )}
    </DynamicVideoStyled>
  );
};

export default DynamicVideo;
